export const formatDate = (dt) => {
    if(typeof dt==="undefined" || dt === null || dt?.replaceAll("") === "")
      return "";
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    var strDate = "";
    try {strDate = new Date(dt).toLocaleDateString('en-GB',options).split(" ").filter((item,index)=>index>0).join(" ").trim()}
    catch(err) { strDate = dt}
    return strDate;
}
  
export const formatDateShort = (dt) => {
    if(typeof dt==="undefined" || dt === null || dt?.replaceAll("") === "")
      return "";
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    var strDate = "";
    try {strDate = new Date(dt).toLocaleDateString('en-GB',options).split(" ").filter((item,index)=>index>0).join(" ").trim()}
    catch(err) { strDate = dt}
    return strDate;
}

export const Months = (month) => {

    const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    if(month >=1 && month <= 12)
        return months[month];
    else    
        return "";
}
  
  